import { createI18n } from 'vue-i18n';
import messages from './strings/index';

/**
 * In vue-i18n 9+ non c'e piu un plugin da installare sul costruttore globale: si crea l'istanza e la
 * si passa con `app.use(i18n)`. La riga `Vue.use(VueI18n)` che stava qui era fra l'altro **duplicata**
 * in `main.ts`.
 *
 * Attenzione a chi usa l'istanza **fuori** da un componente: in vue-i18n 8 si scriveva `i18n.t(...)`,
 * dalla 9 la funzione sta sotto `i18n.global.t(...)`. Sono 24 chiamate in cinque file - il grosso in
 * `TheSidebar/menu-items.ts`, che compone le voci di menu - e l'errore che producono e
 * `i18n.t is not a function`, cioe una pagina bianca senza altre spiegazioni.
 *
 * `legacy: true` tiene l'API di Vue 2 - `this.$t`, `this.$d`, `this.$n` nei componenti - che e usata
 * in centinaia di punti. Passare alla Composition API (`useI18n`) e una migrazione a se, da fare
 * quando il porting dei componenti sara chiuso: infilarla qui significherebbe toccare ogni file due
 * volte.
 */
const FORMATI_NUMERO = {
  currency: {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'symbol',
  },
} as const;

const i18n = createI18n({
  legacy: true,
  locale: 'it',
  fallbackLocale: 'it',
  messages,
  /*
   * I due avvisi di traduzione sono spenti, e la ragione non e la comodita.
   *
   * 59 componenti dichiarano un blocco `i18n` **locale** (46 nel gestionale, 13 nel portale, 164 chiavi
   * in tutto). Ogni volta che uno di essi cerca una chiave **globale**, vue-i18n emette due avvisi -
   * `Not found … in 'it' locale messages` e `Fall back … with root locale` - poi la trova nella radice e
   * mostra il testo giusto. Sono ~44 avvisi su una sola pagina, e nel giorno in cui li ho misurati sono
   * stati il posto dove si e nascosto un errore di render che teneva chiusa una pagina intera.
   *
   * Serve `silentTranslationWarn` e non basta `silentFallbackWarn`: il secondo da solo non spegne
   * niente - verificato, 44 avvisi prima e 44 dopo - perche entrambi gli avvisi nascono dal percorso
   * della chiave mancante nello scope locale, che e governato dal primo.
   *
   * **Il prezzo, e come e pagato.** Cosi si tacciono anche le chiavi davvero mancanti. Al loro posto c'e
   * un controllo statico, `scratchpad/controlla-chiavi-i18n.mjs`, che verifica **ogni** `$t('…')` del
   * codice contro il bundle: copre tutti i punti d'uso, non solo quelli che capita di renderizzare, ed
   * e quindi piu completo del rumore che sostituisce.
   */
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  numberFormats: {
    it: FORMATI_NUMERO,
    // `it-IT` non e un doppione: quindici chiamate passano la lingua **esplicitamente**, nella forma
    // `$n(valore, 'currency', 'it-IT')`. vue-i18n 8 ripiegava su `it` quando la lingua richiesta non
    // aveva quel formato; dalla 9 non lo fa piu, e ogni cella che chiedeva un importo mancava il
    // formato. Effetto misurato: aprendo "Dettaglio calcoli" la pagina **muore** - il renderer viene
    // chiuso, non rallentato - lasciando lo spinner acceso. L'unico indizio era un avviso
    // `[intlify] Not found 'currency' key in 'it-IT' locale messages`, ripetuto a ogni ridisegno.
    'it-IT': FORMATI_NUMERO,
  },
});

export default i18n;
